import AccordionTabs from './accordion-tabs';

export default AccordionTabs;
